import { createAction } from 'redux-actions';

export const getFeedFiltersRequest = createAction('GET_FEED_FILTERS_REQUEST');
export const getFeedFiltersSuccess = createAction('GET_FEED_FILTERS_SUCCESS');
export const getFeedFiltersFail = createAction('GET_FEED_FILTERS_FAIL');

export const createFeedFilterRequest = createAction('CREATE_FEED_FILTER_REQUEST');
export const createFeedFilterSuccess = createAction('CREATE_FEED_FILTER_SUCCESS');
export const createFeedFilterFail = createAction('CREATE_FEED_FILTER_FAIL');
